import { createTheme } from '@mui/material';

export const FONT_FAMILY_BASE = '"Inter", "Roboto", "Segoe UI", system-ui, sans-serif';

export const theme = createTheme({
    typography: {
        fontFamily: FONT_FAMILY_BASE,
    },
});
